import React, { useEffect, useState } from "react";
import './AddForm.css';
import { useNavigate } from "react-router-dom";
import { getMaterialManufactureUrl, getMaterialUrl } from '../config/api';
import axios from 'axios';

const typeToCode: Record<string, 'pe' | 'ppr' | 'pvh'> = {
    "Полиэтилен": 'pe',
    "Полипропилен": 'ppr',
    "Поливинилхлорид": 'pvh',
};

interface ManufacturerInfo {
    id?: number;
    material_name?: string;
    purpose?: string;
    manufacture?: string;
}

// Статические данные для материалов
const materialData: { [key: string]: { [key: string]: { purpose: string; manufacturer?: string } } } = {
    pe: {
        'plast02651': { purpose: 'Натуральный тр.', manufacturer: 'Газпром нефтехим Салават' },
        'HD03490NP': { purpose: 'Натуральный тр.', manufacturer: 'ЗапСибНефтехим' },
        'HD03594PE': { purpose: 'Трубный', manufacturer: 'ЗапСибНефтехим' },
        'HM0349PE': { purpose: 'Натуральный тр.', manufacturer: 'SOCAR Polymer' },
        'HM0359PE': { purpose: 'Трубный', manufacturer: 'SOCAR Polymer' },
        'PE6PP32': { purpose: 'Натуральный тр.', manufacturer: 'Ставролен' },
        'p2nt119': { purpose: '-', manufacturer: 'Казаньоргсинтез' },
        'HD12500LB': { purpose: 'Выдувное формов.', manufacturer: 'Казаньоргсинтез' },
        'stavrolen27383': { purpose: 'Выдувное формов.', manufacturer: 'Ставролен' },
        'HD07580SB': { purpose: 'Выдувное формов.', manufacturer: 'Казаньоргсинтез' },
        'plast27673': { purpose: 'Выдувное формов.', manufacturer: 'Ставролен' },
        'HD03580SB': { purpose: 'Выдувное формов.', manufacturer: 'ЗапСибНефтехим' },
        'HD10530LB': { purpose: 'Выдувное формов.', manufacturer: 'ЗапСибНефтехим' },
        'PE100RC': { purpose: 'Трубный', manufacturer: '-' }
    },
    ppr: {
        'PPI013GP5': { purpose: 'Трубный', manufacturer: 'ЗапСибНефтехим' },
        'PPG200224': { purpose: 'Трубный', manufacturer: 'ЗапСибНефтехим' },
        'PPH250GP2': { purpose: 'Трубный', manufacturer: 'ЗапСибНефтехим' },
        'plast1030': { purpose: 'Трубный', manufacturer: 'Ставролен' },
        'PPG103508': { purpose: 'Трубный', manufacturer: 'ЗапСибНефтехим' },
        'PPH030GPTomskneftehim': { purpose: 'Трубный', manufacturer: 'Томскнефтехим' },
        'PPH030GPNeftehimia': { purpose: 'Трубный', manufacturer: 'Нефтехимия' },
        'PPH030GPPolium': { purpose: 'Трубный', manufacturer: 'Полиум' },
        'PPH030GPZapSibNeftehim': { purpose: 'Трубный', manufacturer: 'ЗапСибНефтехим' },
        'SIBEX_PP_R003_EX1': { purpose: 'Трубный', manufacturer: 'СИБУР' }
    },
    pvh: {
        'C70Y': { purpose: 'Трубный', manufacturer: 'Казаньоргсинтез' },
        'PC271': { purpose: 'Трубный', manufacturer: 'Казаньоргсинтез' },
        'SI70': { purpose: 'Трубный', manufacturer: 'Казаньоргсинтез' },
        'C5868PG': { purpose: 'Трубный', manufacturer: 'Казаньоргсинтез' },
        'C6359M': { purpose: 'Трубный', manufacturer: 'Казаньоргсинтез' },
        'C6669PG': { purpose: 'Трубный', manufacturer: 'Казаньоргсинтез' },
        'RC267': { purpose: 'Трубный', manufacturer: 'Казаньоргсинтез' },
        'C6669GC': { purpose: 'Трубный', manufacturer: 'Казаньоргсинтез' },
        'SI67': { purpose: 'Трубный', manufacturer: 'Казаньоргсинтез' },
        'C7059M': { purpose: 'Трубный', manufacturer: 'Казаньоргсинтез' }
    }
};

// Расшифровка названий для таблицы
const getLabelForKey = (key: string): string => {
    const labels: { [key: string]: string } = {
        'plast02651': '0,26/51',
        'HD03490NP': 'HD 03490 NP',
        'HD03594PE': 'HD 03594 PE',
        'HM0349PE': 'HM 0349 PE',
        'HM0359PE': 'HM 0359 PE',
        'PE6PP32': 'PE 6PP 32',
        'p2nt119': 'П2НТ 119',
        'HD12500LB': 'HD 12500 LB',
        'stavrolen27383': '273-83 Ставролен',
        'HD07580SB': 'HD 07580 SB',
        'plast27673': '276-73',
        'HD03580SB': 'HD 03580 SB',
        'HD10530LB': 'HD 10530 LB',
        'PE100RC': 'PE 100 RC',
        'PPI013GP5': 'PPI 013 GP5',
        'PPG200224': 'PPG 200 224',
        'PPH250GP2': 'PPH 250 GP2',
        'plast1030': '1030',
        'PPG103508': 'PPG 103 508',
        'PPH030GPTomskneftehim': 'PPH 030 GP Томскнефтехим',
        'PPH030GPNeftehimia': 'PPH 030 GP Нефтехимия',
        'PPH030GPPolium': 'PPH 030 GP Полиум',
        'PPH030GPZapSibNeftehim': 'PPH 030 GP ЗапСибНефтехим',
        'SIBEX_PP_R003_EX1': 'SIBEX PP R003 EX1',
        'C70Y': 'C70Y',
        'С-70У': 'C70Y',
        'PC271': 'PC271',
        '271PC': 'PC271',
        'SI70': 'SI70',
        'СИ-70': 'SI70',
        'C5868PG': 'C5868PG',
        'С 5868ПЖ': 'C5868PG',
        'C6359M': 'C6359M',
        'С-6359М': 'C6359M',
        'C6669PG': 'C6669PG',
        'С-6669ПЖ': 'C6669PG',
        'RC267': 'RC267',
        '267RC': 'RC267',
        'C6669GC': 'C6669GC',
        'С 6669ЖС': 'C6669GC',
        'SI67': 'SI67',
        'CИ-67': 'SI67',
        'C7059M': 'C7059M',
        'С 7059М': 'C7059M'
    };
    return labels[key] || key;
};

interface MaterialActualData {
    id?: number;
    index: number;
    date: string;
    [key: string]: any;
}

const MaterialForm = () => {
    const [selectedMaterialType, setSelectedMaterialType] = useState<string>("");
    const [materialDataState, setMaterialDataState] = useState<MaterialActualData[]>([]);
    const [editablePrices, setEditablePrices] = useState<{ [key: string]: string }>({});
    const [selectedDate, setSelectedDate] = useState<string>('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [manufacturerList, setManufacturerList] = useState<ManufacturerInfo[]>([]);
    const [manufacturerError, setManufacturerError] = useState<string>('');
    const navigate = useNavigate();

    // Загрузка актуальных данных при выборе материала
    useEffect(() => {
        if (!selectedMaterialType) {
            setMaterialDataState([]);
            setEditablePrices({});
            setManufacturerList([]);
            setManufacturerError('');
            return;
        }

        const code = typeToCode[selectedMaterialType];
        if (!code) {
            return;
        }

        const url = getMaterialUrl(code, 'actual/');
        const access = localStorage.getItem('access');
        setIsLoading(true);
        setManufacturerError('');
        let isMounted = true;

        axios.get(url, { headers: access ? { Authorization: `Bearer ${access}` } : {} })
            .then(({ data }) => {
                if (!isMounted) {
                    return;
                }
                if (Array.isArray(data) && data.length > 0) {
                    setMaterialDataState(data);
                    const latestData = data[data.length - 1];
                    const prices: { [key: string]: string } = {};
                    Object.entries(latestData)
                        .filter(([key]) => key !== 'index' && key !== 'date' && key !== 'id')
                        .forEach(([key, value]) => {
                            prices[key] = String(value || '');
                        });
                    setEditablePrices(prices);
                } else {
                    setMaterialDataState([]);
                    setEditablePrices({});
                }
            })
            .catch(err => {
                if (!isMounted) {
                    return;
                }
                console.error('Ошибка загрузки данных:', err);
                setError('Ошибка загрузки данных');
                setMaterialDataState([]);
                setEditablePrices({});
            })
            .finally(() => {
                if (isMounted) {
                    setIsLoading(false);
                }
            });

        axios.get(getMaterialManufactureUrl(code), { headers: access ? { Authorization: `Bearer ${access}` } : {} })
            .then(({ data }) => {
                if (!isMounted) {
                    return;
                }
                if (Array.isArray(data)) {
                    setManufacturerList(data);
                    setManufacturerError('');
                } else {
                    throw new Error('Некорректный формат данных производителей');
                }
            })
            .catch(err => {
                if (!isMounted) {
                    return;
                }
                console.error('Ошибка загрузки производителей:', err);
                setManufacturerList([]);
                setManufacturerError('Не удалось загрузить производителей');
            });

        return () => {
            isMounted = false;
        };
    }, [selectedMaterialType]);

    const handleMaterialSelect = (materialType: string) => {
        setSelectedMaterialType(materialType);
        setError('');
        setSuccessMessage('');
        setSelectedDate('');
        setManufacturerList([]);
        setManufacturerError('');
    };

    const handlePriceChange = (grade: string, value: string) => {
        setEditablePrices(prev => ({
            ...prev,
            [grade]: value
        }));
    };

    const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedDate(e.target.value);
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        
        if (!selectedMaterialType || !selectedDate) {
            setError('Пожалуйста, выберите материал и дату');
            return;
        }

        try {
            const code = typeToCode[selectedMaterialType];
            if (!code) throw new Error('Неверно выбран тип материала');

            const access = localStorage.getItem('access');
            const url = getMaterialUrl(code, 'create/');
            
            const payload: Record<string, any> = { date: selectedDate };
            Object.entries(editablePrices).forEach(([grade, price]) => {
                if (price.trim() !== '') {
                    payload[grade] = price;
                }
            });

            await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    ...(access ? { Authorization: `Bearer ${access}` } : {})
                }
            });

            setSuccessMessage('Данные успешно отправлены!');
            setError('');
            
            const actualUrl = getMaterialUrl(code, 'actual/');
            const { data } = await axios.get(actualUrl, { 
                headers: access ? { Authorization: `Bearer ${access}` } : {} 
            });
            
            if (Array.isArray(data) && data.length > 0) {
                setMaterialDataState(data);
                const latestData = data[data.length - 1];
                const prices: { [key: string]: string } = {};
                Object.entries(latestData)
                    .filter(([key]) => key !== 'index' && key !== 'date' && key !== 'id')
                    .forEach(([key, value]) => {
                        prices[key] = String(value || '');
                    });
                setEditablePrices(prices);
            }
            
        } catch (error) {
            console.error('Ошибка при отправке данных:', error);
            setError(error instanceof Error ? error.message : 'Не удалось отправить данные');
        }
    };


    const latestData = materialDataState.length > 0 ? materialDataState[materialDataState.length - 1] : null;
    const materialInfo = selectedMaterialType ? materialData[typeToCode[selectedMaterialType]] : {};
    const rows = latestData
        ? Object.entries(latestData)
            .filter(([key]) => key !== 'index' && key !== 'date' && key !== 'id')
            .map(([grade, price]) => ({ grade, price }))
        : [];

    const normalizeName = (value?: string) =>
        (value || '')
            .toLowerCase()
            .replace(/э/g, 'е')
            .replace(/[^a-zа-я0-9]/gi, '');

    // Статическая карта полиэтилена
    const frontToServerName: Record<string, string> = {
        'П2НТ 119': 'ПЭ2НТ11-9',
        'PE 6PP 32': 'PE6PP32',
        'PE 100 RC': 'PE 100RC (синий)',
        'HM 0359 PE': 'HM 0359 PE',
        'HM 0349 PE': 'HM 0349 PE',
        'HD 12500 LB': 'HD 12500 LB',
        'HD 10530 LB': 'HD 10530 LB',
        'HD 07580 SB': 'HD 07580 SB',
        'HD 03594 PE': 'HD 03594 PE',
        'HD 03580 SB': 'HD 03580 SB',
        'HD 03490 NP': 'HD 03490 NP',
        '276-73': '276-73',
        '273-83 Ставролен': '273-83 Ставролен',
        '0,26/51': '0,26/51',
    };

    // Карта соответствий для PVH (русские названия в базе -> английские для отображения)
    const pvhServerToDisplay: Record<string, string> = {
        '271PC': 'PC271',
        'СИ-70': 'SI70',
        'С 5868ПЖ': 'C5868PG',
        'С-6359М': 'C6359M',
        'С-6669ПЖ': 'C6669PG',
        '267RC': 'RC267',
        'С 6669ЖС': 'C6669GC',
        'CИ-67': 'SI67',
        'С 7059М': 'C7059M',
        'С-70У': 'C70Y',
    };

    const findManufacturerForGrade = (grade: string, index: number) => {
        const label = getLabelForKey(grade);
        const normalizedGrade = normalizeName(grade);
        const normalizedLabel = normalizeName(label);

        // Собираем все возможные варианты названий для поиска
        const searchVariants: Set<string> = new Set([normalizedLabel, normalizedGrade]);

        const mappedServerName = frontToServerName[label];
        const normalizedMapped = mappedServerName ? normalizeName(mappedServerName) : null;
        if (normalizedMapped) {
            searchVariants.add(normalizedMapped);
        }

        // Для PVH: добавляем все варианты русских и английских названий
        const code = typeToCode[selectedMaterialType];
        if (code === 'pvh') {
            for (const [russianName, englishName] of Object.entries(pvhServerToDisplay)) {
                const normalizedRussian = normalizeName(russianName);
                const normalizedEnglish = normalizeName(englishName);
                
                if (normalizedGrade === normalizedEnglish || normalizedLabel === normalizedEnglish ||
                    normalizedGrade === normalizedRussian || normalizedLabel === normalizedRussian) {
                    searchVariants.add(normalizedRussian);
                    searchVariants.add(normalizedEnglish);
                }
            }
        }

        let match: ManufacturerInfo | undefined;

        const searchVariantsArray = Array.from(searchVariants);

        // 1. Точное совпадение по всем вариантам
        for (const searchVariant of searchVariantsArray) {
            match = manufacturerList.find((item) => {
                if (!item.material_name) return false;
                const itemNorm = normalizeName(item.material_name);
                return itemNorm === searchVariant;
            });
            if (match) break;
        }

        // 2. Частичное совпадение
        if (!match) {
            match = manufacturerList.find((item) => {
                if (!item.material_name) return false;
                const itemNorm = normalizeName(item.material_name);
                for (const searchVariant of searchVariantsArray) {
                    if (
                        itemNorm.includes(searchVariant) ||
                        searchVariant.includes(itemNorm)
                    ) {
                        return true;
                    }
                }
                return false;
            });
        }

        // 3. Позиция (fallback)
        if (!match) {
            match = manufacturerList[index];
        }

        return { label, match };
    };

    return (
        <div className="form-page-container">
            <nav className="breadcrumbs" style={{ marginLeft: 15, alignSelf: 'flex-start' }}>
                <span
                    className="breadcrumb-home"
                    style={{ color: 'rgba(0,0,0,0.5)', cursor: 'pointer', fontWeight: 400 }}
                    onClick={() => navigate('/')}
                >
                    Главная страница
                </span>
                <span style={{ margin: '0 8px', color: 'rgba(0,0,0,0.3)' }}>/</span>
                <span className="breadcrumb-current" style={{ fontWeight: 500, color: '#000' }}>
                    Обновление цен материалов
                </span>
            </nav>

            <div className="form-card" style={{ marginTop: 10 }}>
                <h2>Обновление цен материалов</h2>
                
                {/* Выбор материала - 3 плашки */}
                <div style={{ marginBottom: '20px' }}>
                    <h3 style={{ marginBottom: '15px', fontSize: '16px', fontWeight: '500' }}>Выберите тип материала:</h3>
                    <div className="material-selection-cards">
                        {Object.keys(typeToCode).map((materialType) => (
                            <div
                                key={materialType}
                                onClick={() => handleMaterialSelect(materialType)}
                                className={`material-card ${selectedMaterialType === materialType ? 'selected' : ''}`}
                            >
                                {materialType}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Таблица с актуальными ценами */}
                {selectedMaterialType && (
                    <div style={{ marginBottom: '20px' }}>
                        <h3 style={{ marginBottom: '15px', fontSize: '16px', fontWeight: '500' }}>
                            Актуальные цены - {selectedMaterialType}
                        </h3>
                        {latestData && (
                            <div style={{ marginBottom: '10px', color: '#666', fontSize: '14px' }}>
                                Дата: {new Date(latestData.date).toLocaleDateString('ru-RU', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: '2-digit'
                                }).replace(/\./g, '.')}
                            </div>
                        )}
                        {manufacturerError && (
                            <div className="price-table-warning">
                                {manufacturerError}
                            </div>
                        )}
                        
                        {isLoading ? (
                            <div style={{ textAlign: 'center', padding: '20px' }}>Загрузка...</div>
                        ) : (
                            <div className="price-table-container">
                                <table className="price-table">
                                    <thead>
                                        <tr>
                                            <th>Марка полимера</th>
                                            <th>Стоимость</th>
                                            {selectedMaterialType === 'Полиэтилен' && (
                                                <>
                                                    <th>Назначение полимера</th>
                                                </>
                                            )}
                                            <th>Производитель</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.length > 0 ? (
                                            rows.map(({ grade }, index) => {
                                                const { label, match: manufacturerInfo } = findManufacturerForGrade(grade, index);
                                                const manufacturerName = manufacturerInfo?.manufacture || '-';
                                                const purposeValue = materialInfo?.[grade]?.purpose || manufacturerInfo?.purpose || '-';
                                                return (
                                                    <tr key={grade}>
                                                        <td>
                                                            {label}
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                value={editablePrices[grade] || ''}
                                                                onChange={(e) => handlePriceChange(grade, e.target.value)}
                                                                className="price-input"
                                                                placeholder="Введите цену"
                                                            />
                                                        </td>
                                                        {selectedMaterialType === 'Полиэтилен' && (
                                                            <td>
                                                                {purposeValue}
                                                            </td>
                                                        )}
                                                        <td>
                                                            <span>{manufacturerName}</span>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={selectedMaterialType === 'Полиэтилен' ? 4 : 3} style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                                                    Нет данных
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                )}

                {/* Форма для выбора даты и отправки */}
                {selectedMaterialType && (
                    <form onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
                        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap',alignItems: 'center' }}>
                            <div style={{ flex: '1', minWidth: '200px' }}>
                                <label htmlFor="date" style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                                    Дата обновления:
                                </label>
                                <input
                                    type="date"
                                    id="date"
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                    className="input"
                                    required
                                    style={{ width: '100%' }}
                                />
                            </div>
                            <div>
                                <button 
                                    type="submit" 
                                    className="submit-button"
                                    disabled={!selectedDate || isLoading}
                                    style={{
                                        marginTop: '20px',
                                        padding: '10px 20px',
                                        backgroundColor: selectedDate && !isLoading ? '#3a6eb3' : '#ccc',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: selectedDate && !isLoading ? 'pointer' : 'not-allowed',
                                        fontSize: '14px',
                                        fontWeight: '500'
                                    }}
                                >
                                    {isLoading ? 'Отправка...' : 'Обновить цены'}
                                </button>
                            </div>
                        </div>
                    </form>
                )}

                {error && <div className="form-error-message">{error}</div>}
                {successMessage && <div className="form-success-message">{successMessage}</div>}
            </div>
        </div>
    );
};

export default MaterialForm;